import React from "react";
import { Stack, FormGroup, ListItemText, Grid, Divider, Paper, FormLabel } from "@mui/material";
import User from "../../types/User";
import UserAutocomplete from "../Shared/UserAutocomplete";
import Actions, { ActionProps } from "./Actions";
import SplitRow from "./SplitRow";
import { ChangeProps } from "./Solution";
import { LessonState } from "../../types/Lessons";
import { SolutionStateLabel, StateButton } from "../Solutions/Buttons";
import dayjs from "dayjs";

type ToolbarProps = {
  users: Array<User>;
}

const Toolbar = (props: ToolbarProps & ActionProps & ChangeProps) => {

  const usersSelectable = props.lesson && (LessonState[props.lesson.state] === LessonState.draft || (props.lesson.owner?.id === props.user.id && LessonState[props.lesson.state] !== LessonState.approved));

  return (
    <Stack spacing={3}>
      <Paper sx={{p: 3}}>
        <FormGroup>
          <p><strong>Solution manager</strong></p>
        </FormGroup>
        
        <Grid container spacing={2}>
        { props.lesson && <>
          <SplitRow label="State">
            <ListItemText sx={{margin: 0}}>{ SolutionStateLabel[props.lesson.state]?.toUpperCase() ?? String(props.lesson.state).toUpperCase() } { LessonState[props.lesson.state] !== LessonState.draft && <StateButton lesson={props.lesson} size="small" /> }</ListItemText>
          </SplitRow>

          { props.lesson?.owner && <SplitRow label="Owner">
            <ListItemText sx={{margin: 0}}>{ props.lesson.owner.display_name }</ListItemText>
          </SplitRow> }

          { !usersSelectable ? <SplitRow label="Approver">
            <ListItemText sx={{margin: 0}}>{props.lesson.approver?.display_name}</ListItemText>
          </SplitRow> : <SplitRow label="Approver">
            <UserAutocomplete
              options={props.users ?? []}
              value={props.lesson.approver}
              placeholder="Add a responsible approver"
              onChange={user => {
                let newParam = { approver: user?.id ?? null }
                props.onChange(newParam);
                props.onSave(newParam);
              }}
            />
          </SplitRow> }

          <Grid size={12}>
            <Divider sx={{mb: 2}} />
            <Actions {...props} />
          </Grid>
          </> }
        </Grid>
      </Paper>
    </Stack>
  )
}

export default Toolbar;